import { Pages } from "./types";

export const enum AnalyticsPageInfraAssistant {
  InfraAssistant = "InfraAssistant",
}

export const pagesInfraAssistant: Pages<AnalyticsPageInfraAssistant> = {
  [AnalyticsPageInfraAssistant.InfraAssistant]: ["Spacelift Intelligence", "Infra Assistant"],
};
